module.exports = __webpack_public_path__ + "img/zhiwei.f86e6f31.png";